document.addEventListener('DOMContentLoaded', function () {
    lazyLoadBackgrounds();
});

function lazyLoadBackgrounds() {
    const lazyBackgrounds = document.querySelectorAll('[data-bg-img]');

    if ('IntersectionObserver' in window) {
        const backgroundObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const lazyBackground = entry.target;
                    lazyBackground.style.backgroundImage = `url('${lazyBackground.dataset.bgImg}')`;
                    backgroundObserver.unobserve(lazyBackground);
                }
            });
        });

        lazyBackgrounds.forEach(function (lazyBackground) {
            backgroundObserver.observe(lazyBackground);
        });
    } else {
        lazyBackgrounds.forEach(function (lazyBackground) {
            lazyBackground.style.backgroundImage = `url('${lazyBackground.dataset.bgImg}')`;
        });
    }
}